// Capture is a mobile file-picker enhancement, not proof of a physical camera.
export function supportsMobileCapture(nav, coarsePointer, captureAttribute) {
  const mobile = nav?.userAgentData?.mobile === true || /Android|iPhone|iPad|iPod/i.test(nav?.userAgent || '')
    || (/Macintosh/i.test(nav?.userAgent || '') && Number(nav?.maxTouchPoints || 0) > 1);
  return mobile && coarsePointer && captureAttribute;
}
